import { styled } from "@material-ui/core";

export const WarningBanner = styled("aside")(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,
  padding: theme.spacing(2),
}));
